import { Grid, Typography } from "@mui/material";
import ColumnContainer from "./ColumnContainer";
import RowContainer from "./RowContainer";
import { CloudUploadRounded } from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import { styled } from "@mui/system";
import { FormattedMessage } from "react-intl";

const StyledUploadSection = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  minHeight: "210px",
  backgroundColor: "var(--bkg-primary)",
  padding: "20px",
  border: "2px dashed var(--text-primary)",
  borderRadius: "16px",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  cursor: "pointer",
  "&.dragging": {
    border: "2px dashed var(--main-color)",
    opacity: "0.5",
  },
  "& .success-upload-icons": {
    "svg:first-of-type": {
      cursor: "auto",
      color: "var(--success)",
    },
    "svg:last-child": {
      cursor: "pointer",
      color: "var(--error)",
    },
  },
  "& .upload-cloud-icon": {
    color: "var(--text-primary)",
  },
}));

const UploadFileComponent = ({
  onFileUpload,
  onFileChange,
  onFileInputRefChange,
  onFileSizeError,
  acceptedFormatsString,
  instructions,
  children,
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const fileInput = useRef(null);
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      if (file.size > process.env.REACT_APP_MAX_FILE_SIZE) {
        onFileSizeError(true);
        return;
      }
      onFileUpload(file);
      onFileChange(file);
      // Reset the file input value to allow uploading the same file again
      event.target.value = null;
      onFileSizeError(false);
    }
  };

  const handleOpenFileInput = () => {
    fileInput.current.click();
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    handleFileChange({ target: { files: [file] } });
  };

  useEffect(() => {
    onFileInputRefChange(fileInput);
  }, [fileInput, onFileInputRefChange]);

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <StyledUploadSection className={isDragging ? "dragging" : ""}>
          <ColumnContainer
            onClick={handleOpenFileInput}
            onDragEnter={handleDragEnter}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            className={`upload-section ${isDragging ? "dragging" : ""}`}
          >
            <RowContainer center>
              <ColumnContainer center align="center" sx={{ gap: "0.5rem" }}>
                <CloudUploadRounded
                  className="upload-cloud-icon"
                  fontSize="large"
                />
                <input
                  accept={acceptedFormatsString}
                  style={{ display: "none" }}
                  type="file"
                  ref={fileInput}
                  id="file-upload"
                  onChange={handleFileChange}
                ></input>
                <Typography
                  textAlign={"center"}
                  variant="caption"
                  component="p"
                  display="block"
                  fontSize={"16px"}
                  id="file-upload"
                >
                  {instructions}
                </Typography>
                <Typography
                  textAlign={"center"}
                  component="p"
                  display="block"
                  fontSize={"16px"}
                  color={"var(--main-color)"}
                  fontWeight={800}
                >
                  <FormattedMessage id="file.formats" /> {acceptedFormatsString}
                  , Max 10 MB
                </Typography>
              </ColumnContainer>
            </RowContainer>
            {children}
          </ColumnContainer>
        </StyledUploadSection>
      </Grid>
    </Grid>
  );
};
export default UploadFileComponent;
